import api from '../api'

//default state
export const DEFAULT_STATE = {
    isLoading: false,
    error: null,
    groups: [],
};

export const CREATE_GROUP = 'CREATE_USER';
export const CREATE_GROUP_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_USER_FAILURE';

export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';

//selectors
export const getIsGroupLoading = (state) => state && state.group && state.group.isLoading;
export const getGroups = (state) => state && state.group && state.group.groups;
export const getError = (state) => state && state.group && state.group.error;

//actions
export const fetchCreateGroup = (groupInfo) => (dispatch, state) => {
    dispatch({
        type: CREATE_GROUP
    })
    api.createGroup(groupInfo)
        .then(res => {
            dispatch({
                type: CREATE_GROUP_SUCCESS,
            })
            dispatch(fetchGroups())
        })
        .catch(err => dispatch({
            type: CREATE_GROUP_FAILURE,
            payload: err.response.data.error
        }))
}

export const fetchGroups = () => (dispatch, state) => {
    dispatch({
        type: GET_GROUPS
    })
    api.getGroups()
        .then(res => {
            dispatch({
                type: GET_GROUPS_SUCCESS,
                payload: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: GET_GROUPS_FAILURE,
                payload: err
            })
        })
}

//reducer
// eslint-disable-next-line
export default function (state = DEFAULT_STATE, action) {
    const { type, payload } = action;

    switch (type) {
        case CREATE_GROUP:
            return { ...state, isLoading: true, error: null, isUserSaved: false }
        case CREATE_GROUP_SUCCESS:
            return { ...state, isLoading: false, error: null, isUserSaved: true }
        case CREATE_GROUP_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case GET_GROUPS:
            return { ...state, isLoading: state.groups.length > 0 ? false : true, error: null }
        case GET_GROUPS_SUCCESS:
            return { ...state, isLoading: false, error: null, groups: payload }
        case GET_GROUPS_FAILURE:
            return { ...state, isLoading: false, error: payload }

        default:
            return state;
    }
}